export const locale = {
    lang: 'es',
    data: {
        'INFO': {
            'VIDEO':{
                'TITTLE':'Videos instruccionales de la NOM-035-SPTS-2018',
                'SEC1':{
                    'NAME':'Sección 1',
                    'TITTLE':'Conformación del grupo de trabajo',

                },
                'SEC2':{
                    'NAME':'Sección 2',
                    'TITTLE':'Capacitación para todos',

                },
                'SEC3':{
                    'NAME': 'Sección 3',
                    'SEC3':'Actividades de planeación y coordinación',

                },'SEC4':{
                    'NAME': 'Sección 4',
                    'SEC4':'Sensibilización para grupo de trabajo',
                },'SEC5':{
                    'NAME':'Sección 5',
                    'SEC5':'Alteraciones a la salud',
                }
                
            },
            'QUES':{
                'TITTLE':'Preguntas frecuentes de la NOM-035-STPS-2018',
                'SEC1':{
                    'TITTLE':'Sección 1'

                },
                'SEC2':{
                    'TITTLE':'Sección 2'

                },
                'SEC3':{
                    'TITTLE':'Sección 3'

                },
                'SEC4':{
                    'TITTLE':'Sección 4'

                },
            }
        }
    }
};
